<div class="account-details">
  <!-- Loading Indicator -->
  <div *ngIf="isLoading" class="loading-overlay">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <div class="card">
    <div class="card-header">
      <div class="row-cols-1 title">
        <h4>Personal information</h4>
    </div>
  </div>

  <div class="profile-section">
    <div class="row profile-picture">
      <div class="col-auto avatar-wrapper align-items-center d-flex">
        <app-user-profile-avatar [user]="currentUser?.name || ''" />
      </div>
      <div class="col-auto control">
        <div class="text-center mb-2">
          <p class="label-text">Profile picture</p>
        </div>
        <div class="button-container">
          <button class="btn btn-primary" (click)="toggleEditProfile()">
            <i class="material-icons">{{ isEditingProfile ? 'cancel' : 'edit' }}</i>
            {{ isEditingProfile ? 'Cancel' : 'Edit Profile' }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="horizontal-divider"></div>

  <div class="form-section">
    <form [formGroup]="profileForm" (ngSubmit)="saveProfileChanges()" class="profile-user-info">
      <div class="section-title">
        <i class="material-icons">account_circle</i>
        <h5>User Information</h5>
      </div>

      <div class="row user-name-info">
        <div class="col-auto">
          <label class="form-label">First name</label>
          <input
            class="form-control"
            type="text"
            formControlName="firstName"
            [readonly]="!isEditingProfile"
            placeholder="Your first name"
          />
          <div *ngIf="isProfileControlInvalid('firstName')" class="input-error form-hint mt-1">
            <i class="material-icons me-1">error_outline</i> First name is required
          </div>
        </div>
        <div class="col-auto">
          <label class="form-label">Last name</label>
          <input
            class="form-control"
            type="text"
            formControlName="lastName"
            [readonly]="!isEditingProfile"
            placeholder="Your last name"
          />
          <div *ngIf="isProfileControlInvalid('lastName')" class="input-error form-hint mt-1">
            <i class="material-icons me-1">error_outline</i> Last name is required
          </div>
        </div>
      </div>

      <div class="section-title mt-4">
        <i class="material-icons">contact_mail</i>
        <h5>Contact Information</h5>
      </div>

      <div class="row user-email-info">
        <div class="col-auto">
          <label class="form-label">Email Address</label>
          <input
            class="form-control"
            type="email"
            formControlName="email"
            [readonly]="!isEditingProfile"
            placeholder="Your email address"
          />
          <div *ngIf="isProfileControlInvalid('email')" class="input-error form-hint mt-1">
            <i class="material-icons me-1">error_outline</i> Valid email is required
          </div>
        </div>
      </div>

      <div *ngIf="isEditingProfile" class="row mt-4 action-row">
        <div class="col-auto d-flex justify-content-center">
          <button type="submit" class="btn btn-primary" [disabled]="profileForm.invalid">
            <i class="material-icons">save</i> Save Changes
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
